// LIBRARIES
import styled, { css } from "styled-components";

// MISC
import {
  COLORS,
  BORDER_RADIUS,
  SIZE,
  DEVICE_TYPE,
  MARGIN,
} from "constants/variables";
import { ImgProps, TextPlacement } from "./NewsAndMediaModel";

//ASSET
import cursorIcon from "assets/img/Cursor.png";

export const NewsAndMediaSectionContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 110px ${SIZE.max200} 0 ${SIZE.max200};

  position: relative;
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    padding: 164px ${SIZE.max100} ${SIZE.max100} ${SIZE.max100};
    height: 100%;
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    padding: 164px ${MARGIN.fix24} ${MARGIN.fix32} ${MARGIN.fix24};
    height: 100%;
  }
`;
export const SvgBackground = styled.div`
  position: absolute;
  left: 0;
  bottom: 0%;
  z-index: 0;
  background-repeat: no-repeat;
`;

export const Container = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, auto);
  gap: 24px;

  z-index: 1;
  grid-template-areas:
    "officialAnnouncements agenda news "
    "events info kitMedia ";

  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, auto) auto;
    gap: 12px;
    grid-template-areas:
      "officialAnnouncements"
      "agenda"
      "news"
      "events"
      "info"
      "kitMedia";
  }
`;

export const Card = styled.div<{
  backgroundColor: string;
  textColor: string;
  gridArea: string;
  biggerCursor?: boolean;
}>`
  z-index: 2;
  padding: ${SIZE.max40};
  border-radius: ${BORDER_RADIUS.radius24};
  text-align: left;
  position: relative;
  max-height: 224px;
  height: 14.3rem;
  min-height: 164px;
  width: 100%;
  min-width: 150px;
  overflow: hidden;
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  border: solid 1px ${COLORS.AbsoluteWhite};
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ textColor }) => textColor};
  grid-area: ${({ gridArea }) => gridArea};
  opacity: 0.96;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    height: 164px;
  }
  &:hover {
    opacity: 1;
  }
`;

export const TextWrapper = styled.div<{ placement: TextPlacement }>`
  z-index: 10;
  display: flex;
  ${({ placement }) =>
    placement === TextPlacement.right
      ? css`
          justify-content: flex-end;
          text-align: right;
          flex-direction: column;
        `
      : css`
          justify-content: flex-start;
          text-align: left;
        `}
  padding: ${SIZE.max10};
`;
export const ImgWrapper = styled.div<{
  position: { bottom?: string; left?: string; right?: string; top?: string };
  transform?: string;
  opacity?: number;
}>`
  position: absolute;
  z-index: 100;
  bottom: ${({ position }) => position.bottom || "auto"};
  left: ${({ position }) => position.left || "auto"};
  right: ${({ position }) => position.right || "auto"};
  top: ${({ position }) => position.top || "auto"};
  transform: ${({ transform }) => transform || "none"};
  opacity: ${({ opacity }) => opacity || 1};
`;

export const Img = styled.img<ImgProps>`
  ${({ imgProps }) => {
    switch (imgProps) {
      case "svg-officialAnnouncements":
        return css`
          height: 224px;
        `;
      case "svg-agenda":
        return css`
          margin-left: -22px;
          @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
            width: 190px;
          }
        `;
      case "svg-news":
        return css`
          height: 224px;
          width: auto;
          @media (max-width: ${DEVICE_TYPE.tablet}) {
            height: 224px;
            width: auto;
          }
        `;
      case "svg-events":
        return css`
          width: 138px;
          height: 141px;
          @media (max-width: ${DEVICE_TYPE.tablet}) {
            height: 117px;
            width: 120px;
          }
        `;
      case "svg-info":
        return css`
          width: 138px;
          height: 141px;
          @media (max-width: ${DEVICE_TYPE.tablet}) {
            height: 117px;
            width: 120px;
          }
        `;
      case "svg-kitMedia":
        return css`
          width: auto;
          height: 173px;
          margin-bottom: 24px;
          margin-right: 24px;
          @media (max-width: ${DEVICE_TYPE.tablet}) {
            width: auto;
            height: 133px;
            margin-bottom: 16px;
            margin-right: 16px;
          }
        `;
      default:
        return css``;
    }
  }}
`;

export const ButtonWrapper = styled.a`
  height: 100%;
  margin-top: 16px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;

  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    height: 60%;
    align-items: flex-end;
  }
`;
